import React from "react";
// Customizable Area Start
import {
  createTheme,
  ThemeProvider,
  styled,
} from '@mui/material/styles';
import { Box, Typography } from "@mui/material";
import CustomDropdown from "../../../components/src/CustomSelectDropdown.web";
import MultiSelectDropdown from "../../../components/src/MultiSelectDropdown.web";
import MultiLevelDropdown from "../../../components/src/MultiLevelDropdown.web";

export const theme = createTheme({
  typography: {
    fontFamily: "Montserrat !important",
    h3: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "19.5px",
    },
    body1: {
      fontFamily: "Montserrat !important",
      fontSize: "12px !important",
      fontWeight: "500 !important",
      lineHeight: "14.63px !important",
    }
  }
});


import FiltersController, {
  configJSON,
  Props,
} from "./FiltersController.web";
// Customizable Area End

export default class Filters extends FiltersController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  // Customizable Area End

  render() {
    // Customizable Area Start
    const { 
      locations, 
      languages,
      selectedSkills,
      skillsCategories,
      skillsSubCategories,
      isGettingSubCategories,
      selectedGender,
      selectedLocation,
      selectedAgeRange,
      selectedLanguages,
    } = this.state;
    // Customizable Area End
    return (
      // Customizable Area Start
      <ThemeProvider theme={theme}>
        <Wrapper>
          <Box className="container">
            <Box className="filterTitle" mb={2}>
              <Typography variant="h3" data-test-id="filterTitle">{configJSON.filterTitle}</Typography>
            </Box>
            <Box className="filterFieldsWrapper">
              <Box>
                <MultiLevelDropdown
                  data-test-id="skills"
                  categories={skillsCategories}
                  subCategories={skillsSubCategories}
                  isGettingSubCategories={isGettingSubCategories}
                  selectedItem={selectedSkills}
                  setSelectedItems={this.handleSkillsChange}
                  handleCategoryClick={this.handleCategoryClick}
                  placeholder="Skills"
                  btnCustomStyle={{
                    width: "150px",
                    height: "48px"
                  }}
                  menuCustomStyle={{
                    width: "150px",
                  }}
                />
              </Box>
            <Box>
              <CustomDropdown
                data-test-id="location"
                selectedItem={selectedLocation}
                setSelectedItem={this.handleLocationChange}
                items={locations}
                isAbleToSearch={true}
                btnCustomStyle={{
                  width: "150px",
                  height: "48px"
                }}
                menuCustomStyle={{
                  width: "150px",
                }}
                placeholder="Location"
              />
            </Box>
            <Box>
              <CustomDropdown
                data-test-id="gender"
                selectedItem={selectedGender}
                setSelectedItem={this.handleGenderChange}
                items={configJSON.GENDER_OPTIONS}
                btnCustomStyle={{
                  width: "150px",
                  height: "48px"
                }}
                menuCustomStyle={{
                  width: "150px",
                }}
                placeholder="Gender"
              />
            </Box>
            <Box>
              <MultiSelectDropdown
                data-test-id="ageRange"
                selectedItems={selectedAgeRange}
                setSelectedItems={this.handleAgeRangeChange}
                items={configJSON.AGE_RANGE_OPTIONS}
                btnCustomStyle={{ 
                  width: "150px", 
                  height: "48px" 
                }}
                menuCustomStyle={{ width: "150px" }}
                placeholder="Age Range"
              />
            </Box>
            <Box>
              <MultiSelectDropdown
                data-test-id="language"
                selectedItems={selectedLanguages}
                setSelectedItems={this.handleLanguageChange}
                items={languages}
                btnCustomStyle={{ 
                  width: "210px", 
                  height: "48px" 
                }}
                menuCustomStyle={{ width: "210px" }}
                placeholder="Language Spoken"
              />
            </Box>
          </Box>
          </Box>
        </Wrapper>
      </ThemeProvider>
      // Customizable Area End
    );
  }
}

// Customizable Area Start
const Wrapper = styled("div")(({ theme }) => ({
  "& .container": {
    // style for container
  },
  "& .filterFieldsWrapper": {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
  }
}));
// Customizable Area End
